import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Redirect } from 'react-router';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import 'base/initialize.scss';
import * as serviceWorker from './serviceWorker';
import UserRepository from 'service/repository';
import { BrowserRouter, Switch, Route, useHistory } from 'react-router-dom';
import { useAppContext } from 'use-app';
import Login from 'features/login';
import Home from 'features/home';
import BrowserNotSupport from 'features/borswer-not-support';
import PageNotFound from 'componets/page-not-found';
import { PATH } from 'config/path';
import useInit from 'hooks/use-init';
import Maintenance from 'componets/maintenance';
import axios from 'axios';
import { maintenanceConfigUrl } from 'config/config';

export const repo = new UserRepository();

const Root = () => {
  console.log('v6.0.5');

  const [pending, setPending] = useState(true);
  const history = useHistory();
  const [maintenanceConfig, setMaintenanceConfig] = useState(null);

  useInit();

  useEffect(() => {
    axios
      .get(maintenanceConfigUrl, {
        timeout: 2000,
      })
      .then(res => {
        let data = res.data.default;

        if (data['all'].enabled) {
          setMaintenanceConfig(data['all']);
        } else if (data.hasOwnProperty('web')) {
          setMaintenanceConfig(data['web']);
        } else {
          setMaintenanceConfig({ enabled: false });
        }
      })
      .catch(err => {
        console.log(err);
        setMaintenanceConfig({ enabled: false });
      });
  }, []);

  useEffect(() => {
    if (!maintenanceConfig || maintenanceConfig.enabled) return;

    const { protocol, host, pathname } = window.location;

    // 如果不是 https 就導向 https
    if (protocol.indexOf('https') === -1) {
      window.location.href = `https://${host}${pathname}`;
    }

    if (process.env.REACT_APP_DEPLOY_ENV === 'prod') {
      if (host.indexOf('autopass.xyz') === -1) {
        window.location.href = `https://enterprise.autopass.xyz${pathname}`;
      }
    }

    // IE 8-10 的 user agent 會帶有 MSIE，IE 11 則是帶有 Trident
    const ua = navigator.userAgent;
    // 找到 IE 8-11 的瀏覽器用戶，導向瀏覽器不支援的說明頁
    if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident') !== -1) {
      // 導向不支援 IE 頁面，要檢查當下 pathname 導過不再導
      if (pathname !== PATH.BROWSER_NOT_SUPPORT) {
        history.push('/browser-not-support');
      }
    }

    setPending(false);
  }, [maintenanceConfig]); //eslint-disable-line

  if (maintenanceConfig && maintenanceConfig?.enabled) {
    return <Maintenance title={maintenanceConfig.title} content={maintenanceConfig.content} />;
  } else if (pending) {
    return <></>;
  } else {
    return (
      <Switch>
        <Route exact path="/">
          <Redirect to={PATH.LOGIN} />
        </Route>
        <Route path={PATH.BROWSER_NOT_SUPPORT} component={BrowserNotSupport} />
        <Route exact path={PATH.LOGIN} component={Login} />
        <Route exact path={PATH.PROFILE} component={Home} />
        <Route exact path={PATH.LICENSE_PLATES} component={Home} />
        <Route exact path={PATH.DRIVERS} component={Home} />
        <Route exact path={PATH.PAYMENT} component={Home} />
        <Route exact path={PATH.DEBIT_ACCOUNT_TRANSACTIONS} component={Home} />
        <Route exact path={PATH.ADD_CREDIT_CARD} component={Home} />
        <Route exact path={PATH.ORDERS} component={Home} />
        <Route exact path={PATH.STATS} component={Home} />
        <Route exact path={PATH.COUPON} component={Home} />
        <Route exact path={PATH.POINTS} component={Home} />
        <Route path="*" component={PageNotFound} />
      </Switch>
    );
  }
};

const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <useAppContext.Provider>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </useAppContext.Provider>
  </QueryClientProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
